import { DateValue } from '@razorpay/blade/components';
import { GetPayrollSetupResponse } from 'api/gql-utils/user/types';
import { CtcBreakdownData } from 'components/PayDetails/types';
import { routePaths } from 'components/Routes/data';
import { SalaryStructure } from 'components/SalaryStructure/types';
import { ValidationSchema } from 'forms';
import { CustomSalaryComponent } from './components/CustomSalaryComponents/types';

export const revisePaySteps = {
  step1: 0,
  step2: 1,
  step3: 2,
};

export const revisePayRouteToStepMap = {
  [routePaths.payDetails.compensation.edit.root]: revisePaySteps.step1,
  [routePaths.payDetails.compensation.edit.salaryDetails]: revisePaySteps.step1,
  [routePaths.payDetails.compensation.edit.review]: revisePaySteps.step3,
};

export const revisePayRouteToStepMapWithMSS = {
  [routePaths.payDetails.compensation.edit.root]: revisePaySteps.step1,
  [routePaths.payDetails.compensation.edit.salaryDetails]: revisePaySteps.step1,
  [routePaths.payDetails.compensation.edit.updateStructure]: revisePaySteps.step2,
  [routePaths.payDetails.compensation.edit.review]: revisePaySteps.step3,
};

export const SALARY_PAY_TYPES = {
  FIXED: 'fixed',
  VARIABLE: 'variable',
  NON_PAYABLE: 'non_payable_benefit',
};

export type ReviseSalaryFormData = {
  salaryStructureId?: string[];
  revisedCompensation: string;
  effectiveFrom: DateValue;
  effectivePayrollMonth: string; // this will be based on the payroll cycle
  currentAnnualCtc: number; // in rupees
  currentCtcEffectiveFrom: string;
  payrollSetupInfo: GetPayrollSetupResponse;
  ctcData: CtcBreakdownData;
  salaryStructureData?: SalaryStructure[];
  isCustomSalaryStructure: boolean;
  customSalaryComponents?: CustomSalaryComponent[];
  salaryStructureForUserInDb?: SalaryStructure;
};

export const reviseSalarySchema: ValidationSchema<ReviseSalaryFormData> = {
  revisedCompensation: (formData) => {
    if (!formData.revisedCompensation) return 'This is required';
    if (formData.revisedCompensation === '0') return 'This is required';
    if (!/^\d+$/.test(formData.revisedCompensation)) {
      return 'Please enter a valid number without decimals';
    }
    return null;
  },
};
